var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSheets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 91,
    viewBox: "0 0 77 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.2709,
    y: 21.2248,
    width: 41.8556,
    height: 58.9106,
    rx: 7,
    transform: "rotate(2.5 26.2709 21.2248)",
    fill: "#EEEEEE",
    stroke: "#999999",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.111427,
    y: 16.9101,
    width: 45.8556,
    height: 62.9105,
    rx: 9,
    transform: "rotate(-7.5 0.111427 16.9101)",
    fill: "#FAFAFA",
    stroke: "#999999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27761 25.7026C1.70091 21.3221 4.78448 17.3035 9.16496 16.7268L36.7822 13.0909C41.1627 12.5142 45.1813 15.5978 45.758 19.9782L46.5424 25.9363L3.062 31.6606L2.27761 25.7026Z",
    fill: "#EEEEEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54.1699,
    y: 13.8735,
    width: 1.82732,
    height: 6.09105,
    rx: 0.913658,
    transform: "rotate(82.5 54.1699 13.8735)",
    fill: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4824,
    y: 3.78345,
    width: 1.82732,
    height: 6.09105,
    rx: 0.913658,
    transform: "rotate(-7.5 37.4824 3.78345)",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.1895,
    y: 5.44556,
    width: 1.82732,
    height: 6.09105,
    rx: 0.913658,
    transform: "rotate(37.5 48.1895 5.44556)",
    fill: "#999999"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.60742,
    y: 33.5198,
    width: 35.3281,
    height: 2.43642,
    rx: 1.21821,
    transform: "rotate(-7.5 7.60742 33.5198)",
    fill: "#DCDCDC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.19727,
    y: 45.5974,
    width: 35.3281,
    height: 2.43642,
    rx: 1.21821,
    transform: "rotate(-7.5 9.19727 45.5974)",
    fill: "#DCDCDC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7881,
    y: 57.6753,
    width: 35.3281,
    height: 2.43642,
    rx: 1.21821,
    transform: "rotate(-7.5 10.7881 57.6753)",
    fill: "#DCDCDC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.24316,
    y: 38.3508,
    width: 12.7912,
    height: 2.43642,
    rx: 1.21821,
    transform: "rotate(-7.5 8.24316 38.3508)",
    fill: "#EEEEEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 9.83398,
    y: 50.4287,
    width: 12.7912,
    height: 2.43642,
    rx: 1.21821,
    transform: "rotate(-7.5 9.83398 50.4287)",
    fill: "#EEEEEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4238,
    y: 62.5066,
    width: 12.7912,
    height: 2.43642,
    rx: 1.21821,
    transform: "rotate(-7.5 11.4238 62.5066)",
    fill: "#EEEEEE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheets);
export default __webpack_public_path__ + "static/media/sheets.63ecb466781bfdfe8817cf585c5d62ca.svg";
export { ForwardRef as ReactComponent };